import type { FaireProductEntity } from "../../entity_types/product";

export const p_5gara9zu2u: FaireProductEntity = {
  token: "p_5gara9zu2u",
  type: "product",
  name: "Woon Bamboo Temple Black Tea",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl:
    "https://cdn.faire.com/fastly/cf22a39727ff3b20cda5af73590585da52583a98bce2e4b4793435445b5d4bbb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/09e54b14fe23885867ff39aded50604e6182c7a361f7074d13eb3d4f0347ba3a.jpeg",
    "https://cdn.faire.com/fastly/ffd79885741b0ba4a0627de2ea0525bccefd4875d320713475c7f9226041804f.jpeg",
    "https://cdn.faire.com/fastly/3918bad4fb6fee0b3db1859b7f7a9c799b73f7795e3ae6aeb0510dce2e010dd1.jpeg",
  ],
  priceDollars: 16,
  description:
    "Take home the same loose leaf tea we cold brew! This is a black tea that drinks very smooth and buttery. There are hints of malt which make it really tasty withe some added milk. It is great served hot or chilled.\n\n𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n• For hot tea, use 1 tsp tea for every 8 oz. of hot water and steep for 4-5 minutes.\n• For cold brew, place 2 tbsp tea in container and add 32 oz of water. Steep for at least 4 hours or overnight, strain and enjoy!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:27:48.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
